<template>
  <div class="results-header" >


    <div class="column is-one-third">
      <div class="results-count" v-if="total > 0">
        <span class="is-color-red">{{ total }}</span> {{ $t('search_results') }}
      </div>
      <div class="results-count" v-else>
        <span class="is-color-red">0</span> {{ $t('search_results') }}
      </div>

    </div>

    <div class="column is-one-third">
      <table class="view-table" align="center">
        <tr>
          <td>
            <label>{{ $t('view-choice') }} :</label>
          </td>
          <td>
            <b-button v-on:click="$root.$emit('select_view','card')" class="view-button is-large"
                      :class="{'selected' : selectedView==='card'}" rounded>
              <span class="fa fa-th-large"></span>
            </b-button>
          </td>
          <td>
            <span class="separator">|</span>
          </td>
          <td>
            <b-button v-on:click="$root.$emit('select_view','row')" class="view-button is-large"
                      :class="{'selected' : selectedView==='row'}" rounded>
              <span class="fa fa-th-list"></span>
            </b-button>
          </td>
        </tr>
      </table>
    </div>

    <div class="column is-one-third view-table" v-if="selectedView==='card'">
      <table align="right">
        <tr>
          <td><label>{{$t('sort')}}&nbsp;: </label></td>
          <td>



      <b-select
          v-model="sort"
          size="is-large is-full" rounded
          v-if="filtersList.length>0"
      >
        <option :key="'name/1'" :value="'name/1'">{{$t('alpha_order')}} ({{$t('ascendant')}})</option>
        <option :key="'name/0'" :value="'name/0'">{{$t('alpha_order')}} ({{$t('descendant')}})</option>
        <template
            v-for="attribute in filtersList"
        >
          <option :key="attribute.attribute+'/1'"
                  :value="attribute.attribute+'/1'">{{ attribute.title }} ({{$t('ascendant')}})
          </option>
          <option :key="attribute.attribute+'/0'"
                  :value="attribute.attribute+'/0'">{{ attribute.title }} ({{$t('descendant')}})
          </option>
        </template>
        <option :key="'isBestSeller/0'" :value="'isBestSeller/0'">Best Seller</option>
        <option :key="'isNew/0'" :value="'isNew/0'">{{$t('new')}}</option>
      </b-select>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ResultsHeader",

  computed: {
    ...mapState({
      total: state => state.searchMachines.total,
      filtersList: state => state.searchMachines.filtersList,
      selectedView: state => state.searchMachines.selectedView,
    }),
    sort: {
      get () {
        return this.$store.state.searchMachines.sort
      },
      set (value) {
        //this.$store.commit('searchMachines/setSort', value)
        this.$root.$emit('select_sort',value)
      }
    }
  }
}
</script>

<style scoped>

</style>